import { Trans } from 'react-i18next';

import { SubscriptionEnding } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { dateFormatter, useTranslate } from '@dreryk/react-common';
import { Logo, StrongText, Text } from '@dreryk/react-components';

import { subscriptionEndingTranslationKeys } from '../../translations';

import { StyledSubscriptionEndingModalList } from './StyledSubscriptionEndingModalList';
import { StyledSubscriptionEndingModalLogo } from './StyledSubscriptionEndingModalLogo';

type SubscriptionEndingModalContentProps = {
   readonly subscriptionEnding: SubscriptionEnding;
};

export const SubscriptionEndingModalContent = (props: SubscriptionEndingModalContentProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <>
         <div>
            <Text testId={'dearUser'}>{translate(subscriptionEndingTranslationKeys.dearUser)}</Text>
            <StyledSubscriptionEndingModalList>
               <li>
                  <Text testId={'anotherSubscriptionYearStart'}>
                     {
                        <Trans
                           i18nKey={subscriptionEndingTranslationKeys.anotherSubscriptionYearStart}
                           values={{
                              date: dateFormatter(props.subscriptionEnding.nextSubscriptionStartDate),
                           }}
                           components={{ bold: <StrongText testId={'date'} />, br: <br /> }}
                        />
                     }
                  </Text>
               </li>
               <li>
                  <Text testId={'invoiceForNextBillingPeriodWillBeIssuedInKsef'}>
                     {
                        <Trans
                           i18nKey={subscriptionEndingTranslationKeys.invoiceForNextBillingPeriodWillBeIssuedInKsef}
                           components={{ bold: <strong /> }}
                        />
                     }
                  </Text>
               </li>
            </StyledSubscriptionEndingModalList>
         </div>
         <StrongText testId={'thankYou'}>{translate(subscriptionEndingTranslationKeys.thankYou)}</StrongText>
         <StyledSubscriptionEndingModalLogo>
            <Logo testId={'logo'} />
         </StyledSubscriptionEndingModalLogo>
      </>
   );
};
